import React from 'react';
import { Line } from 'react-chartjs-2';

const ColourGraph = ({ series, hoverLabel, fillColour = '#50a1ff', className }) => {
	const formattedData = {
		labels: series.map(({ x }) => x),
		datasets: [
			{
				label: hoverLabel,
				fill: true,
				cubicInterpolationMode: 'monotone',
				data: series.map(({ y }) => y),
				backgroundColor: fillColour,
				pointRadius: 0,
				pointHitRadius: 4,
				borderColor: fillColour
			}
		]
	};

	// option documentation:
	// https://www.chartjs.org/docs/latest/charts/line.html#dataset-properties
	let options = {
		responsive: true,
		legend: {
			display: false
		},
		spanGaps: true,
		maintainAspectRatio: false,
		gridLines: {
			display: false,
			zeroLineWidth: 0
		},
		scales: {
			xAxes: [
				{
					display: false
				}
			],
			yAxes: [
				{
					beginAtZero: true,
					gridLines: {
						drawBorder: false
					},
					ticks: {
						suggestedMin: 0
					}
				}
			]
		}
	};

	return <Line className={className} data={formattedData} options={options} />;
};

export default ColourGraph;
